import { useTranslation } from "react-i18next";
//
import { allLangs, defaultLang } from "./config";
import { useSettingsContext } from "@/components/settings";

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();

  const { onChangeDirectionByLang } = useSettingsContext();

  const mapLocale = (locale: string): string => {
    const normalizedLocale = locale.toLowerCase();
    if (normalizedLocale === "zh-cn" || normalizedLocale === "zh_cn") {
      return "zh-CN";
    } else if (normalizedLocale === "en") {
      return "en";
    }
    return locale;
  };

  const langStorage =
    typeof window !== "undefined" ? localStorage.getItem("i18nextLng") : "";

  const currentLang =
    allLangs.find((_lang) => _lang.value === mapLocale(langStorage || "en")) ||
    defaultLang;

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
    // 同步更改至缓存
    onChangeDirectionByLang(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text: any, options?: any) => translate(text, options) as any,
    currentLang,
    allLangs,
  };
}
